import { cn } from '@shigo-ui/ui';

export function dashboardTableTextActionClassName(className?: string) {
  // my-0! cancels the row's in-cell `[&_button]:-my-2`: a text-height button needs no overlap,
  // and inside the truncating name cell the negative margin clips the text.
  return cn(
    'text-[var(--shigo-highlight)] hover:opacity-80 block cursor-pointer truncate border-0 bg-transparent p-0 my-0! text-left text-[13px]! font-medium! transition-opacity focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none',
    className,
  );
}

export function dashboardTableActionMenuContentClassName(className?: string) {
  return cn('w-52', className);
}

export function dashboardTableActionMenuItemClassName(className?: string) {
  return cn(
    'text-foreground focus:text-[var(--shigo-highlight)] data-[highlighted]:text-[var(--shigo-highlight)] cursor-pointer gap-2 text-sm font-normal focus:bg-[var(--shigo-highlight-surface)] data-[highlighted]:bg-[var(--shigo-highlight-surface)] [&>svg]:h-4 [&>svg]:w-4',
    className,
  );
}

export function dashboardTableMutedTextClassName(className?: string) {
  return cn('text-muted-foreground block truncate text-[13px] font-normal', className);
}

export function dashboardTableFilterTriggerClassName(className?: string) {
  return cn(
    'border-input bg-card h-9 w-full justify-between rounded-md px-3 py-2 text-sm shadow-[var(--shadow-control)] hover:bg-card focus-visible:ring-1 sm:w-[180px]',
    className,
  );
}

export function dashboardTableSelectTriggerClassName(className?: string) {
  return cn(
    'bg-card h-9 w-full rounded-md text-sm shadow-[var(--shadow-control)] sm:w-[180px]',
    className,
  );
}
